/**
 * @generated SignedSource<<f6461e6c6d836d7dca72d5aad10e6461>>
 * @relayHash 4a8a9e049dcad9843b5d59376e53ceb8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6eb7271950c55c9701a8edde14106467de0061f5e932aabdb753ee6d78aa112f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BacklogAggAppDataQuery } from './BacklogAggAppDataQuery.graphql';

const node: PreloadableConcreteRequest<BacklogAggAppDataQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6eb7271950c55c9701a8edde14106467de0061f5e932aabdb753ee6d78aa112f",
    "metadata": {},
    "name": "BacklogAggAppDataQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
